/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ValidatePalNpiResponse } from './ValidatePalNpiResponse';
import {
    ValidatePalNpiResponseFromJSON,
    ValidatePalNpiResponseFromJSONTyped,
    ValidatePalNpiResponseToJSON,
    ValidatePalNpiResponseToJSONTyped,
} from './ValidatePalNpiResponse';

/**
 * 
 * @export
 * @interface ValidatePalNpi200Response
 */
export interface ValidatePalNpi200Response {
    /**
     * 
     */
    data?: ValidatePalNpiResponse;
}

/**
 * Check if a given object implements the ValidatePalNpi200Response interface.
 */
export function instanceOfValidatePalNpi200Response(value: object): value is ValidatePalNpi200Response {
    return true;
}

export function ValidatePalNpi200ResponseFromJSON(json: any): ValidatePalNpi200Response {
    return ValidatePalNpi200ResponseFromJSONTyped(json, false);
}

export function ValidatePalNpi200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ValidatePalNpi200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : ValidatePalNpiResponseFromJSON(json['data']),
    };
}

export function ValidatePalNpi200ResponseToJSON(json: any): ValidatePalNpi200Response {
    return ValidatePalNpi200ResponseToJSONTyped(json, false);
}

export function ValidatePalNpi200ResponseToJSONTyped(value?: ValidatePalNpi200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': ValidatePalNpiResponseToJSON(value['data']),
    };
}

